/**
 * Debug functionality.
 * 
 * @author Stan Hurks
 */
export default class Debug {
    public static initialized: boolean = false

    /**
     * Initialize the debug functionality.
     */
    public static initialize() {
        Debug.initialized = true;

        /**
         * Finds an element in the page.
         */
        (window as any).findElement = (innerHTML: string): Element|null => {
            const findElement = (element: Element|null): Element|null => {
                if (element === null) {
                    return null
                }
                if (element.innerHTML.toLowerCase().includes(innerHTML.toLowerCase())) {
                    for (let i = 0; i < element.children.length; i ++) {
                        const child = element.children.item(i)
                        if (child?.innerHTML.toLowerCase().includes(innerHTML.toLowerCase())) {
                            return findElement(child)
                        }
                    }
                    return element
                }
                return null
            }
            return findElement(document.body)
        }
    }
}